import { ApiCall } from "common/types/api";

export const slaApi = (apiCall: ApiCall) => ({
  acceptSla: () => apiCall("post", `/api/admin/sla`),
});
